import LocalStorageCache from 'swrv/dist/cache/adapters/localStorage'

export const optionsCache = new LocalStorageCache()
